import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-beta.svg'
import _imports_1 from '@/assets/images/google-wallet.png'
import _imports_2 from '../../../assets/images/404-img.png'


const _withScopeId = n => (_pushScopeId("data-v-42b21b1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "workstation-trade-link"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-trade-link__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "workstation-trade-link__inner" }
const _hoisted_4 = { class: "workstation-trade-link__header" }
const _hoisted_5 = { class: "workstation-trade-link__header-inner" }
const _hoisted_6 = { class: "workstation-trade-link__header-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "workstation-trade-link__header-content" }
const _hoisted_9 = { class: "workstation-trade-link__header-title" }
const _hoisted_10 = { class: "workstation-trade-link__header-tags" }
const _hoisted_11 = { class: "workstation-trade-link__trade-tag" }
const _hoisted_12 = { class: "workstation-trade-link__verify-tag" }
const _hoisted_13 = {
  key: 0,
  class: "tw-flex tw-items-center"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"25\" fill=\"none\" viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" data-v-42b21b1e><g clip-path=\"url(#a)\" data-v-42b21b1e><path d=\"m11.19 1.86-7 3.11C3.47 5.29 3 6.01 3 6.8v4.7c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6.8c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0Zm-1.9 14.93L6.7 14.2a.996.996 0 1 1 1.41-1.41L10 14.67l5.88-5.88a.996.996 0 1 1 1.41 1.41l-6.59 6.59a.996.996 0 0 1-1.41 0Z\" fill=\"#40AE42\" data-v-42b21b1e></path></g><defs data-v-42b21b1e><clipPath id=\"a\" data-v-42b21b1e><path fill=\"#fff\" transform=\"translate(0 .5)\" d=\"M0 0h24v24H0z\" data-v-42b21b1e></path></clipPath></defs></svg>", 1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "tw-flex tw-items-center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verified", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " TRADE CONTRACTOR", -1))
const _hoisted_19 = { class: "workstation-trade-link__rating" }
const _hoisted_20 = { class: "workstation-trade-link__check-list" }
const _hoisted_21 = {
  key: 0,
  class: "workstation-trade-link__check-list-item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "26",
  fill: "none",
  viewBox: "0 0 26 26",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "13",
    cy: "13",
    r: "13",
    fill: "#D7E9FF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m11.27 15.689-2.484-2.412a.713.713 0 0 0-.994 0 .664.664 0 0 0 0 .964l2.974 2.888a.722.722 0 0 0 1.001 0l7.526-7.298a.664.664 0 0 0 0-.965.713.713 0 0 0-.994 0l-7.029 6.823Z",
    fill: "#0C0F4A"
  })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Insurance:", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-trade-link__check-list-item" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "26",
    height: "26",
    fill: "none",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "13",
      cy: "13",
      r: "13",
      fill: "#D7E9FF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m11.27 15.689-2.484-2.412a.713.713 0 0 0-.994 0 .664.664 0 0 0 0 .964l2.974 2.888a.722.722 0 0 0 1.001 0l7.526-7.298a.664.664 0 0 0 0-.965.713.713 0 0 0-.994 0l-7.029 6.823Z",
      fill: "#0C0F4A"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Qualifications"),
    /*#__PURE__*/_createTextVNode(" & "),
    /*#__PURE__*/_createElementVNode("strong", null, "ID")
  ])
], -1))
const _hoisted_26 = { class: "workstation-trade-link__body" }
const _hoisted_27 = { class: "workstation-trade-link__card-list" }
const _hoisted_28 = { class: "workstation-trade-link__card" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-trade-link__card-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "43",
    height: "49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 49"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.515 18.056h14.962v.515a7.465 7.465 0 0 1-7.482 7.483 7.465 7.465 0 0 1-7.48-7.482v-.516ZM21.995.407c-2.192 0-3.956 1.414-3.956 3.173v5.88h-.73a1.281 1.281 0 0 1-1.284-1.286V4.573a10.587 10.587 0 0 0-4.594 7.936h-.918c-.97 0-1.75.78-1.75 1.75v2.045c0 .97.78 1.754 1.75 1.754h.72v.548c0 6.026 4.803 10.877 10.763 10.877 5.963 0 10.762-4.85 10.762-10.877v-.549h.72c.97 0 1.75-.783 1.75-1.753V14.26c0-.97-.78-1.75-1.75-1.75h-.92a10.593 10.593 0 0 0-4.632-7.972v3.638c0 .712-.572 1.285-1.285 1.285h-.69V3.58c0-1.759-1.765-3.173-3.956-3.173Z",
      fill: "#fff"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m24.19 40.258-1.342-4.046 2.262-3.23h-6.228l2.263 3.23-1.343 4.046-6.63-8.33-7.339 3.976c-1.586.86-2.179 1.607-2.753 2.958l-1.985 4.662c-.415 1.777.458 2.45 1.258 2.697 3.4.764 13.042 2.29 19.641 2.29 6.599 0 16.24-1.526 19.644-2.29.796-.248 1.67-.921 1.255-2.697l-1.984-4.662c-.576-1.351-1.168-2.098-2.755-2.958l-7.341-3.978-6.623 8.332Z",
      fill: "#fff"
    })
  ])
], -1))
const _hoisted_30 = { class: "workstation-trade-link__card-content" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Jobs", -1))
const _hoisted_32 = { class: "workstation-trade-link__card" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-trade-link__card-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "57",
    height: "56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 56"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.354 9.766c.75-.546 1.434-1.161 1.912-1.912l5.668 5.668c-.683.615-1.366 1.23-1.912 1.912L8.354 9.766Zm34.624 30.732a25.272 25.272 0 0 1-1.912 1.912l5.668 5.668c.547-.751 1.161-1.434 1.912-1.912l-5.668-5.668Zm-28.956 0-5.668 5.668c.75.546 1.434 1.16 1.912 1.912l5.668-5.668a25.255 25.255 0 0 1-1.912-1.912Zm28.956-24.996 5.668-5.668c-.75-.546-1.434-1.16-1.912-1.912l-5.668 5.668c.614.547 1.297 1.23 1.912 1.912ZM4.598 8.195a4.11 4.11 0 0 0 4.097-4.097A4.11 4.11 0 0 0 4.598 0 4.11 4.11 0 0 0 .5 4.098a4.11 4.11 0 0 0 4.098 4.097Zm0 39.61A4.11 4.11 0 0 0 .5 51.902 4.11 4.11 0 0 0 4.598 56a4.11 4.11 0 0 0 4.097-4.098 4.11 4.11 0 0 0-4.097-4.097Zm47.804-39.61A4.11 4.11 0 0 0 56.5 4.098 4.11 4.11 0 0 0 52.402 0a4.11 4.11 0 0 0-4.097 4.098 4.11 4.11 0 0 0 4.097 4.097Zm0 39.61a4.11 4.11 0 0 0-4.097 4.097A4.11 4.11 0 0 0 52.402 56a4.11 4.11 0 0 0 4.098-4.098 4.11 4.11 0 0 0-4.098-4.097Zm-21.17-15.707h-5.464c-3.005 0-5.463 2.458-5.463 5.463v4.644c2.39 1.434 5.19 2.185 8.195 2.185s5.805-.82 8.195-2.185V37.56c0-3.005-2.458-5.463-5.463-5.463ZM28.5 11.61c-9.015 0-16.39 7.375-16.39 16.39 0 4.849 2.117 9.22 5.463 12.224v-2.663c0-3.688 2.459-6.83 5.805-7.854-1.024-1.229-1.707-2.731-1.707-4.439 0-3.756 3.073-6.829 6.829-6.829s6.83 3.073 6.83 6.83c0 1.707-.615 3.277-1.708 4.438 3.346 1.025 5.805 4.166 5.805 7.854v2.663A16.405 16.405 0 0 0 44.89 28c0-9.015-7.375-16.39-16.39-16.39Zm4.098 13.658a4.11 4.11 0 0 0-4.098-4.097 4.11 4.11 0 0 0-4.098 4.097 4.11 4.11 0 0 0 4.098 4.098 4.11 4.11 0 0 0 4.098-4.098Z",
      fill: "#fff"
    })
  ])
], -1))
const _hoisted_34 = { class: "workstation-trade-link__card-content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Connections", -1))
const _hoisted_36 = { class: "workstation-trade-link__services" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workstation-trade-link__services-header" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Additional services - Book Now!")
], -1))
const _hoisted_38 = { class: "workstation-trade-link__services-list" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "workstation-trade-link__gallery" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "workstation-trade-link__payment_wallets" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_text" }, " Add to Google Wallet", -1))
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"error__page\" data-v-42b21b1e><div class=\"error__page__content\" data-v-42b21b1e><div class=\"error__img\" data-v-42b21b1e><img src=\"" + _imports_2 + "\" alt=\"\" data-v-42b21b1e></div><div class=\"error__content\" data-v-42b21b1e><h5 data-v-42b21b1e>No Data Found</h5><p data-v-42b21b1e>We couldn’t retrieve any data at tha moment</p></div></div></div>", 1)
const _hoisted_48 = [
  _hoisted_47
]

import Loader from "@/core/components/common/Loader.vue";
import ErrorRedIcon from "@/core/components/icons/ErrorRedIcon.vue";
import {
  BusinessDetailTypeEnum,
  UserVerificationStatusEnum,
} from "@/core/enums/RolesEnum";
import {
  displayToastMessage,
  getCombineSameProjectReview,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import { TRADE_ESTIMATES_TRADE_PASSPORT } from "@/modules/project/routes";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { WORKSTATION } from "@/store/modules/workstation";
import { computed, ComputedRef, getCurrentInstance, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import PaymentWalletModal from "../modal/PaymentWalletModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkStationLinkPage',
  setup(__props) {

const loading = ref(false);
const store = useStore();
const route = useRoute();
const router = useRouter();
const internalInstance = getCurrentInstance();
const linkData = ref(null) as any;
const userWorkStationDetails = ref(null) as any;
const userWorkStationGallery = ref(null) as any;
const userSkills = ref(null);
const userWorkStationInsurance = ref(null) as any;
const userWorkStationRates = ref(null) as any;
const isOpenWalletModal = ref(false);

const toggleWalletModal = () => {
  isOpenWalletModal.value = !isOpenWalletModal.value;
};

const getImagePath = (imgUrl: string | null) => {
  if (!imgUrl)
    return require("@/assets/images/workstation-trade-link-image-2.png");

  return setDirectStoragePathToImage(imgUrl);
};
const workStationType = (businessType: string) => {
  return businessType === BusinessDetailTypeEnum.LIMITED_COMPANY
    ? "LTD Company"
    : "Sole Trader";
};

const onClickViewTradePassport = () => {
  if (!userWorkStationDetails.value?.id) return;
  store.dispatch(
    `${TRADE_ESTIMATE_STORE}/viewTradeUserAccount`,
    userWorkStationDetails.value?.id
  );
  router.push({
    name: TRADE_ESTIMATES_TRADE_PASSPORT,
  });
};

const combineSameProjectReview = computed(() => {
  return userWorkStationRates.value
    ? getCombineSameProjectReview(userWorkStationRates.value)
    : [];
});
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});
const onClickGoogleWallet = async () => {
  try {
    await store.dispatch(`${WORKSTATION}/getGooglePaymentWallet`, {
      userWorkStationId: userWorkStationDetails.value?.id,
    });
  } catch (error: any) {
    if (error.response) {
      const errorMessage =
        error.response.data.message ||
        "Something went wrong, please try again later.";
      displayToastMessage(internalInstance, errorMessage, "error");
    } else if (error.request) {
      displayToastMessage(
        internalInstance,
        "No response from server. Please try again later.",
        "error"
      );
    } else {
      displayToastMessage(internalInstance, `Error: ${error.message}`, "error");
    }
  } finally {
    toggleWalletModal();
  }
};
onMounted(async () => {
  try {
    loading.value = true;
    const getLinkData = await store.dispatch(
      `${WORKSTATION}/getWorkStationLinkData`,
      {
        token: route.params.token,
      }
    );
    linkData.value = getLinkData;
    userWorkStationDetails.value = linkData.value.userWorkstationDetails;
    userWorkStationGallery.value = linkData.value.userWorkStationGallery;
    userSkills.value = linkData.value.userSkills;
    userWorkStationInsurance.value =
      linkData.value.userWorkstationDetails.userInsurance;
    userWorkStationRates.value = linkData.value.userWorkStationRates;
  } catch (error) {
    linkData.value = null;
    displayToastMessage(
      internalInstance,
      "WorkStation Link not Valid!",
      "error"
    );
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value && linkData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: getImagePath(userWorkStationDetails.value?.profileImage),
                    loading: "lazy",
                    alt: "workstation images"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(userWorkStationDetails.value?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", null, _toDisplayString(workStationType(
                      userWorkStationDetails.value?.user?.userBusinessDetails?.type
                    )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (
                    userWorkStationDetails.value?.verificationStatus ===
                    _unref(UserVerificationStatusEnum).VERIFIED
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(ErrorRedIcon),
                            _hoisted_17
                          ])),
                      _hoisted_18
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_v_rating, {
                      length: 5,
                      size: 32,
                      modelValue: getAverageOfAllProjectReview.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getAverageOfAllProjectReview).value = $event)),
                      "active-color": "orange",
                      color: "rgba(12, 15, 74, 0.26)",
                      "empty-icon": "mdi-star",
                      readonly: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("p", null, _toDisplayString(getAverageOfAllProjectReview.value) + " stars", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (userWorkStationInsurance.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("p", null, [
                            _hoisted_23,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userWorkStationInsurance.value?.slice(0, 2), (insurance, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: insurance.id
                              }, [
                                _createTextVNode(_toDisplayString(insurance?.metadata?.insuranceName) + " ", 1),
                                (
                        index < userWorkStationInsurance.value.slice(0, 2).length - 1
                      )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, " & "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_25
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("h3", null, _toDisplayString(userWorkStationDetails.value?.jobs), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("h3", null, _toDisplayString(userWorkStationDetails.value?.contractors), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userSkills.value?.slice(0, 5), (skill) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "workstation-trade-link__services-item",
                      key: skill.id
                    }, [
                      (skill.iconName)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            class: "specialisms_multiselect_modal_item_title_icon"
                          }, {
                            default: _withCtx(() => [
                              (skill.iconName)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    style: {"width":"14px"},
                                    src: 
                    require('@/assets/category-icons/' +
                      skill.iconName +
                      '.svg')
                  ,
                                    alt: "icon"
                                  }, null, 8, _hoisted_39))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(skill?.poLabel), 1)
                    ]))
                  }), 128)),
                  (!userSkills.value?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, "No Service Fouund"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userWorkStationGallery.value, (gallary) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "workstation-trade-link__gallery-item",
                    key: gallary.id
                  }, [
                    _createElementVNode("img", {
                      src: getImagePath(gallary?.name),
                      alt: "gallary images"
                    }, null, 8, _hoisted_42)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_v_btn, {
                  class: "apple_wallet footer-btn",
                  onClick: onClickGoogleWallet
                }, {
                  default: _withCtx(() => [
                    _hoisted_44,
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "button button-orange footer-btn",
                  onClick: onClickViewTradePassport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("View Trade Passport ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Loader, { show: loading.value }, null, 8, ["show"]),
    (!linkData.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
      : _createCommentVNode("", true),
    (isOpenWalletModal.value)
      ? (_openBlock(), _createBlock(PaymentWalletModal, {
          key: 2,
          getAverageOfAllProjectReview: getAverageOfAllProjectReview.value,
          data: linkData.value,
          onOnSave: toggleWalletModal,
          onOnCancel: toggleWalletModal
        }, null, 8, ["getAverageOfAllProjectReview", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})